

<template>
<div>
<v-container>
<v-row>
<v-col cols="12" sm="12" lg="12">
   <RegistroComprobantes></RegistroComprobantes>
</v-col>
</v-row>  


<v-row justify="end" >
        
        <v-col cols="2" >





        </v-col>
      </v-row>



</v-container>
   
</div>
</template>

<script>

import RegistroComprobantes from '@/components/economy/RegistroComprobantes.vue';




export default {
    data () {
    return {
             
    }
  },
  components: {
    
    RegistroComprobantes
    
  },
  mounted(){

  


  },

  methods: {

    

}

}
    

</script>


